import React, { useState } from "react";

import useAPI from "services/Api";
import Input from "input/Input";
import Page from "pages/Page";
import { useNotificationManager } from "notifications/NotificationManager";

const ResetPassword = ({ componentName = "[ResetPassword]" }) => {
    const [email, setEmail] = useState("");
    const [emailSent, setEmailSent] = useState(false);

    const API = useAPI();
    const notificationManager = useNotificationManager();

    // ---=== Utilities ===--- //

    const handleSubmit = async(event) => {
        event.preventDefault();
        notificationManager.clearAllNotifications();

        if (email.length < 1) {
            notificationManager.addError("Please Enter Email");
            return;
        }

        await API.api_Post(
            componentName,
            "/password/reset/",
            JSON.stringify({ email: email }),
            notificationManager,
            (_response) => {
                setEmailSent(true);
            },
            (error) => {
                if (error.response?.data?.errors?.[0]?.message) {
                    notificationManager.addError(error.response.data.errors[0].message);
                }
                else {
                    if (error.message !== undefined) {
                        notificationManager.addError(error.message);
                    }
                    else {
                        notificationManager.addError(error);
                    }
                }
            }
        );
    };

    const handleReset = () => {
        setEmailSent(false);
        setEmail("");
    };

    // ---=== Render ===--- //

    return (
        <Page
            componentName={componentName}
            internal={false}
        >
            {
                !emailSent
                    ? (
                        <div className="h-screen flex items-center justify-center pb-12">
                            <div className="w-96 h-96 flex-col justify-start items-center gap-8 inline-flex">
                                <div className="self-stretch h-40 flex-col justify-start items-center gap-6 flex">
                                    <div className="w-14 h-14 p-3.5 rounded-xl shadow border border-gray-200 justify-center items-center inline-flex">
                                        <img className="w-7 h-7 relative flex-col justify-start items-start flex" src="/icons/key-01.svg"/>
                                    </div>
                                    <div className="self-stretch h-20 flex-col justify-start items-start gap-3 flex">
                                        <div className="self-stretch text-center text-gray-900 text-3xl font-semibold leading-9">Forgot password?</div>
                                        <div className="self-stretch text-center text-gray-600 text-base font-normal leading-normal">No worries, we’ll send you reset instructions.</div>
                                    </div>
                                </div>
                                <form className="w-full max-w-sm" onSubmit={handleSubmit}>
                                    <div className="self-stretch h-36 rounded-xl flex-col justify-start items-center gap-6 flex">
                                        <div className="self-stretch h-16 flex-col justify-start items-start gap-5 flex">
                                            <div className="self-stretch h-16 flex-col justify-start items-start gap-1.5 flex">
                                                <div className="self-stretch h-16 flex-col justify-start items-start gap-1.5 flex">
                                                    <div className="text-slate-700 text-sm font-medium leading-tight">Email</div>
                                                    <Input
                                                        className={"shadow appearance-none border rounded-lg w-full py-2.5 px-3.5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"}
                                                        name="Email"
                                                        noLabel
                                                        required
                                                        type="text"
                                                        validations={[{ type: "email", value: email }]}
                                                        value={email}
                                                        // Callbacks
                                                        onChange={(value) => setEmail(value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <button className="self-stretch px-4 py-2.5 bg-brand-600 hover:bg-brand-700 rounded-lg shadow justify-center items-center gap-1.5 inline-flex cursor-pointer">
                                            <div className="px-0.5 justify-center items-center flex">
                                                <div className="text-white text-base font-semibold leading-normal">Reset Password</div>
                                            </div>
                                        </button>
                                    </div>
                                </form>
                                <a href="/src/pages/Login">
                                    <div className="justify-center items-center gap-1.5 inline-flex">
                                        <img className="w-5 h-5" src="/icons/arrow-left.svg"/>
                                        <div className="text-gray-600  text-sm font-semibold leading-tight"> Back to log in</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    )
                    : (
                        <div className="h-screen flex items-center justify-center pb-12">
                            <div className="w-96 h-96 flex-col justify-start items-center gap-12 inline-flex">
                                <div className="self-stretch h-40 flex-col justify-start items-center gap-6 flex">
                                    <div className="w-14 h-14 p-3.5 rounded-xl shadow border border-gray-200 justify-center items-center inline-flex">
                                        <img className="w-7 h-7 relative flex-col justify-start items-start flex" src="/icons/mail-01.svg"/>
                                    </div>
                                    <div className="self-stretch h-20 flex-col justify-start items-start gap-2 flex">
                                        <div className="self-stretch text-center text-gray-900 text-3xl font-semibold pb-2 leading-9">Check your email</div>
                                        <div className="self-stretch text-center text-gray-600 text-base font-normal leading-normal">We sent a password reset link to</div>
                                        <div className="self-stretch text-center text-gray-600 text-base font-medium leading-normal">{email}</div>
                                    </div>
                                </div>
                                <div className="self-stretch h-6 pt-3 rounded-xl flex-col justify-start items-center flex">
                                    <div className="self-stretch h-16 flex-col justify-start items-start gap-5 flex">
                                        <div className="self-stretch text-center text-gray-600 text-sm font-normal leading-normal">
                                            Didn't receive the email?{" "}
                                            <button onClick={handleReset} className="text-brand-600 cursor-pointer">
                                                Try again
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <a href="/src/pages/Login">
                                    <div className="justify-center items-center gap-1.5 inline-flex">
                                        <img className="w-5 h-5" src="/icons/arrow-left.svg" alt="icon"/>
                                        <div className="text-gray-600  text-sm font-semibold leading-tight">Back to login</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    )
            }
        </Page>
    );
};

export default ResetPassword;
